import React from 'react';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './ModalHeadingText.scss';
/**
 * The heading text we use for modals.
 */ const ModalHeadingText = ({ children ,  })=>/*#__PURE__*/ React.createElement(Heading, {
        className: s['root']
    }, children);
ModalHeadingText.displayName = 'ModalHeadingText';
export default ModalHeadingText;
